<template>
    <v-layout align-start justify-start row wrap> 
        <v-flex xs12 class="py-0 mb-0">           
            <span class="red--text py-0 my-0" v-if="errors.collect(attributes.variable,vuexnamespace)">{{ errors.first(attributes.variable, vuexnamespace) }}</span>            
        </v-flex>
        <!-- <code>{{selected}}</code> -->
        <v-flex xs12>
            <small>{{attributes.hint}}</small></br>
        </v-flex>
         
        <v-flex :class="attributes.size" d-flex> 
             <!--           
                <v-input
                    append-icon="close"
                    prepend-icon="search"
                    v-on:click:prepend="openDialog"
                    
                    v-on:click:append="clearSelected"
                    light
                    v-model="result"
                    class="rounded-input"
                    >
                    {{displayresult}}
                </v-input>                                                                       
           
            
             -->
            <div style="display: flex;">
                <div class="pillSearchInputContainer">
                    <div v-on:click="openDialog" class="pSIC_search"><v-icon>search</v-icon></div>
                    <div v-model="result" class="pSIC_text">{{displayresult}}</div>
                    <div v-on:click="clearSelected" class="pSIC_delete"><v-icon>close</v-icon></div>
                </div>
            </div>
                        
            <form-search-dialog
                v-model="selected"
                v-on:closeDialog="onDialogClosed"
                :dialog="dialog"
                :attributes="attributes"
                :vuexnamespace="vuexnamespace"
                >
            </form-search-dialog>
        </v-flex>
        <v-flex xs1></v-flex> 
        <v-flex :class="attributes.invertedsize"></v-flex>          
    </v-layout>    
</template>

<script>
import FormSearchDialog from './FormSearchDialog.vue'
export default {   
    inject: ['$validator'],
    
    props:[
        'attributes',
        'vuexnamespace'
    ],
    data() {
        return {                                   
            dialog:false,
            selected:null
        }
    },
    components:{
        'form-search-dialog':FormSearchDialog
    },
    watch:{
        selected(){
            if(this.selected != null) {
                this.result = this.selected.id
            } else {
                this.result = null
            }
        }
    },
    computed: {
        itemsnamespace: function() {
            return this.attributes.items.split('/')[0]
        },
        displayresult(){
            if (this.selected==null) {
                return ''
            } else {
                return this.selected.name
            }                
        },        
        result: {           
            get() {return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)},
            set(val){this.$store.commit(this.attributes.setter, val)}       
        }       
    },
    methods: {
        openDialog() {
            this.dialog = true
        },
        onDialogClosed(){            
            this.dialog=false
        },
        clearSelected() {
            this.selected = null
        },
        init(){
            if(this.$route.params.id != "undefined") {
                this.selected=this.$store.getters[this.itemsnamespace + '/getsingle'](this.result)
            }
        }
    },
    
    updated() {       
        this.init()
    }
}
</script>
